<!-- Header -->
<div mat-dialog-title
	style="text-align: center; color: #A20000;"
	role="heading">
	RESULTS CANNOT BE DISPLAYED
</div>

<!-- Body -->
<mat-dialog-content style="align-items: center">
	<div>
		This query cannot be processed because there is no way to connect fields from following areas:
	</div>
	<ng-container *ngIf="V10">
		<div *ngFor="let group of unjoinedCategoryGroups">
			[
			<span *ngFor="let category of group; let i = index;">
				{{category.CategoryName}}{{i == group.length - 1 ? '' : ', '}}
			</span>
			]
		</div>
	</ng-container>
	<ng-container *ngIf="!V10">
		<div *ngFor="let group of unjoinedCategoryGroups">
			<span *ngFor="let category of group">
				[{{category.ObjectName}}].[{{category.CategoryName}}]
			</span>
		</div>
	</ng-container>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left"></div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button image="Save.png"
			label="OK"
			(clickEvent)="ok()"></tyl-button>
	</div>
</mat-dialog-actions>